"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _AssignSpeakers = require("./AssignSpeakers");
Object.keys(_AssignSpeakers).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _AssignSpeakers[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _AssignSpeakers[key];
    }
  });
});